/*
 * CHN variant notify (DRAFT, not published).
 *
 * One shared function, chnNotifySync(), decides what the buy box shows for the
 * variant the REAL product form currently holds:
 *   - available   -> native submit button visible, Notify hidden
 *   - unavailable -> native submit button + Shop Pay button get .hidden,
 *                    the email field + ONE "Notify me when available" submit
 *                    button are shown (no separate trigger),
 *                    sticky bars are relabelled and never cart.
 *
 * It is called from two paths (both required):
 *   1. PAGE LOAD   - DOMContentLoaded (or immediately if already parsed). Covers a
 *                    fully sold-out product (native button already server-rendered
 *                    with class sold-out) and a ?variant=<sold-out id> deep link.
 *   2. VARIANT CHANGE - 'simple-variant-picker:variantChange' (dispatched by
 *                    snippets/simple-variant-picker.liquid) and 'change' on the
 *                    form's id input (product-info.js updateVariantInputs).
 *
 * Guards:
 *   - Does nothing unless the snippet root [data-chn-notify] exists, and removes the
 *     root when the page has no real product form (1st Phorm / In-Store Exclusive).
 *   - Finds the product form as form[id^="product-form-"] CONTAINING a submit button. It never uses
 *     form[action*="/cart/add"] alone: that matches the Shop Pay terms form first.
 *   - Reads form ids with getAttribute('id'), never form.id (form.id is the
 *     <input name="id"> element).
 *
 * Signup: Klaviyo client API, email only (see klaviyoSubscribe).
 */
(function () {
  if (window.__chnVariantNotify) return;
  window.__chnVariantNotify = true;

  var root = null;
  var variantsById = {};

  function readVariants(el) {
    var map = {};
    var json = el && el.querySelector('[data-chn-notify-variants]');
    if (!json) return map;
    try {
      JSON.parse(json.textContent).forEach(function (v) {
        map[String(v.id)] = v;
      });
    } catch (e) {
      /* malformed JSON: leave map empty, sync becomes a no-op */
    }
    return map;
  }

  function findProductForm() {
    var candidates = document.querySelectorAll('form[id^="product-form-"]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].querySelector('button[name="add"], button[type="submit"]')) return candidates[i];
    }
    return null;
  }

  function currentVariant(form) {
    var input = form && form.querySelector('input[name="id"]');
    if (!input || !input.value) return null;
    return variantsById[String(input.value)] || null;
  }

  function stickyButtons() {
    return document.querySelectorAll('#StickyATCButton, #stickyAddToCartBtnMobile');
  }

  function setSticky(unavailable) {
    stickyButtons().forEach(function (btn) {
      var label = btn.querySelector('.button-text');
      if (unavailable) {
        if (label && !btn.hasAttribute('data-chn-original-label')) {
          btn.setAttribute('data-chn-original-label', label.textContent);
        }
        btn.setAttribute('data-chn-unavailable', 'true');
        btn.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = 'Notify me when available';
      } else if (btn.hasAttribute('data-chn-unavailable')) {
        btn.removeAttribute('data-chn-unavailable');
        btn.removeAttribute('aria-disabled');
        if (label && btn.hasAttribute('data-chn-original-label')) {
          label.textContent = btn.getAttribute('data-chn-original-label');
        }
      }
    });
  }

  /* One-button layout: the email field and the single submit button are always
     shown together while the variant is unavailable. There is no panel to open or
     close; "open" means scroll to the field and focus it. */
  function closePanel() {
    if (!root) return;
    var status = root.querySelector('[data-chn-notify-status]');
    if (status) status.textContent = '';
  }

  function openPanel() {
    if (!root || root.classList.contains('hidden')) return;
    var email = root.querySelector('input[name="email"]');
    if (email) email.focus({ preventScroll: true });
  }

  /*
   * Button look: the Notify buttons take the EXACT class list and inline style the
   * theme rendered on the native Add to cart button for this template (block
   * settings differ per template), so they match it pixel for pixel. No new CSS.
   * Exception: quantity-incentive templates set body.qi-product-dead on a dead
   * variant, and that rule greys out anything carrying .shop-add-to-cart-button /
   * .product-form__submit and relabels it "Sold Out". In that state the buttons fall
   * back to the theme's own .theme-button so Notify stays usable.
   */
  var BASE_TRIGGER_CLASS = 'chn-notify__trigger';
  var nativeLook = null;

  function captureNativeLook(form) {
    if (nativeLook) return;
    var btn = form && (form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]'));
    if (!btn) return;
    nativeLook = {
      classes: btn.className.split(/\s+/).filter(function (c) {
        return c && c !== 'hidden' && c !== 'sold-out' && c !== 'loading';
      }),
      style: btn.getAttribute('style') || '',
    };
  }

  function applyButtonLook() {
    if (!root || !nativeLook) return;
    var qiDead = document.body.classList.contains('qi-product-dead');
    root.querySelectorAll('[data-chn-notify-submit]').forEach(function (b) {
      if (qiDead) {
        b.className = 'theme-button ' + BASE_TRIGGER_CLASS;
        b.removeAttribute('style');
      } else {
        b.className = nativeLook.classes.join(' ') + ' ' + BASE_TRIGGER_CLASS;
        if (nativeLook.style) b.setAttribute('style', nativeLook.style);
      }
    });
  }

  /* THE shared function. Safe to call any number of times. */
  function chnNotifySync(reason) {
    if (!root) return;
    var form = findProductForm();
    if (!form) return; /* no real cart form on this page: never attach */

    var variant = currentVariant(form);
    if (!variant) return; /* unknown id: leave the theme's own state alone */

    var unavailable = !variant.available;
    var nativeButton = form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    var paymentButton = form.querySelector('.shopify-payment-button');

    /* .hidden (base.css:202, display:none !important) is used instead of the
       hidden attribute: .shop-add-to-cart-button sets display:flex
       (shop-product-details.css:27), which beats the UA [hidden] rule. */
    if (nativeButton) nativeButton.classList.toggle('hidden', unavailable);
    if (paymentButton) paymentButton.classList.toggle('hidden', unavailable);
    root.classList.toggle('hidden', !unavailable);
    form.setAttribute('data-chn-variant-state', unavailable ? 'unavailable' : 'available');

    var idField = root.querySelector('[data-chn-notify-variant-id]');
    if (idField) idField.value = String(variant.id);
    var titleEl = root.querySelector('[data-chn-notify-variant-title]');
    if (titleEl) titleEl.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    root.setAttribute('data-variant-id', String(variant.id));

    if (!unavailable) {
      closePanel();
      var status = root.querySelector('[data-chn-notify-status]');
      if (status) status.textContent = '';
    }

    setSticky(unavailable);
    applyButtonLook();

    document.dispatchEvent(
      new CustomEvent('chn:variant-availability', {
        detail: { variantId: variant.id, available: !unavailable, reason: reason || 'sync' },
      }),
    );
  }

  /*
   * Klaviyo, account XiNyGx (Complete Health). Client API, public company id only.
   * One call per signup, email channel only: back-in-stock subscription on the exact
   * VARIANT (this records the metric the back-in-stock flow triggers on).
   * No list join and no marketing opt-in (Anthony 2026-09-15T20:37:54Z: "We only want to
   * send them back in stock notifs"). Klaviyo sends email back in stock notices without
   * marketing consent; a profile that has unsubscribed from email marketing gets none.
   * SMS (list WzEzvv) is NOT collected until client-approved consent copy exists.
   * No discount copy, no discount code, anywhere.
   */
  var KLAVIYO_COMPANY_ID = 'XiNyGx';
  var KLAVIYO_REVISION = '2024-10-15';

  function klaviyoPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + path + ' ' + res.status);
      return res;
    });
  }

  function klaviyoSubscribe(payload) {
    return klaviyoPost('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: payload.email } } },
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + payload.variantId } },
        },
      },
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    var formEl = e.currentTarget;
    var status = root.querySelector('[data-chn-notify-status]');
    var email = formEl.querySelector('input[name="email"]');
    if (!email || !email.value || (email.checkValidity && !email.checkValidity())) {
      if (status) status.textContent = 'Please enter a valid email.';
      if (email) email.focus();
      return;
    }
    var payload = {
      email: email.value.trim(),
      variantId: root.getAttribute('data-variant-id'),
      productId: root.getAttribute('data-product-id'),
    };
    klaviyoSubscribe(payload).then(
      function () {
        if (status) status.textContent = "You're on the list. We'll let you know when it's back.";
      },
      function (err) {
        if (status) status.textContent = 'Something went wrong. Please try again.';
        if (window.console) console.warn('[chn-variant-notify]', err && err.message);
      },
    );
  }

  /*
   * Sticky bar add path (sections/sticky-add-to-cart.liquid, untouched). Its
   * addToCartSticky() posts #sticky-variant-id, which is rendered as
   * product.variants.first.id and never follows the picker, and it has no
   * availability check. Wrap it: without the sticky's own selects, point the sticky
   * input at the variant the main product form holds, and never cart an
   * unavailable variant (open Notify instead).
   */
  function wrapStickyAdd() {
    var original = window.addToCartSticky;
    if (typeof original !== 'function' || original.__chnWrapped) return;
    var wrapped = function () {
      var form = findProductForm();
      var input = form && form.querySelector('input[name="id"]');
      var hasStickySelects = document.querySelectorAll('.sticky-variant-select').length > 0;
      if (!hasStickySelects && input && input.value) {
        document.querySelectorAll('[id="sticky-variant-id"]').forEach(function (el) {
          el.value = input.value;
        });
      }
      var stickyInput = document.getElementById('sticky-variant-id');
      var v = stickyInput ? variantsById[String(stickyInput.value)] : null;
      if (!v || !v.available) {
        document.dispatchEvent(new CustomEvent('chn:notify-open', { detail: { source: 'sticky' } }));
        return;
      }
      return original.apply(this, arguments);
    };
    wrapped.__chnWrapped = true;
    window.addToCartSticky = wrapped;
  }

  function init() {
    root = document.querySelector('[data-chn-notify]');
    if (!root) return;
    if (!findProductForm()) {
      root.parentNode && root.parentNode.removeChild(root);
      root = null;
      return;
    }
    variantsById = readVariants(root);
    wrapStickyAdd();
    captureNativeLook(findProductForm());
    applyButtonLook();
    new MutationObserver(applyButtonLook).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    /* The snippet renders at the end of the variant picker; place it directly after
       the real product form so Notify sits where the buy button was. */
    var anchorForm = findProductForm();
    var anchor = anchorForm.closest('product-form') || anchorForm;
    if (anchor.parentNode && root.previousElementSibling !== anchor) {
      anchor.parentNode.insertBefore(root, anchor.nextSibling);
    }

    var signup = root.querySelector('[data-chn-notify-form]');
    if (signup) signup.addEventListener('submit', onSubmit);

    /* PATH 2: variant change */
    document.addEventListener('simple-variant-picker:variantChange', function () {
      chnNotifySync('variant-change');
    });
    var form = findProductForm();
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', function () {
        chnNotifySync('id-input-change');
      });
    }

    /* Sticky bar asks to open the panel instead of carting an unavailable variant */
    document.addEventListener('chn:notify-open', function () {
      if (!root || root.classList.contains('hidden')) return;
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      openPanel();
    });

    /* Last line of defence: the product form must never submit an unavailable
       variant (Enter in the quantity input submits it even with the button hidden).
       Capture phase, so it runs before product-form.js's submit handler. */
    document.addEventListener(
      'submit',
      function (e) {
        var f = e.target;
        if (!f || f.tagName !== 'FORM' || f !== findProductForm()) return;
        var v = currentVariant(f);
        if (v && !v.available) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true,
    );

    /* PATH 1: page load (covers fully sold-out products and ?variant= deep links) */
    chnNotifySync('page-load');
  }

  window.chnNotifySync = chnNotifySync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
